import { useState } from 'react';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import { collection, addDoc } from 'firebase/firestore';
import { auth, db } from './firebase';
import './estilo.css';

export default function GerenciarUsuarios() {
  const [novoEmail, setNovoEmail] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [nomeUsuario, setNomeUsuario] = useState('');
  const [timeUsuario, setTimeUsuario] = useState('');
  const [mensagem, setMensagem] = useState('');

  async function cadastrarUsuario() {
    if (!novoEmail.trim() || !novaSenha.trim() || !nomeUsuario.trim() || !timeUsuario.trim()) {
      setMensagem('Preencha todos os campos.');
      return;
    }

    try {
      const userCredential = await createUserWithEmailAndPassword(auth, novoEmail, novaSenha);
      const novoUsuarioUID = userCredential.user.uid;

      await addDoc(collection(db, 'usuarios'), {
        uid: novoUsuarioUID,
        email: novoEmail,
        nome: nomeUsuario,
        time: timeUsuario,
        criadoEm: new Date().toISOString()
      });

      setMensagem('Usuário criado com sucesso.');
      setNovoEmail('');
      setNovaSenha('');
      setNomeUsuario('');
      setTimeUsuario('');
    } catch (error) {
      setMensagem('Erro: ' + error.message);
    }
  }

  return (
    <div className="card">
      <h2>Gerenciamento de Usuários</h2>
      {mensagem && <p className="mensagem">{mensagem}</p>}

      <input
        className="input"
        placeholder="Nome do novo usuário"
        value={nomeUsuario}
        onChange={e => setNomeUsuario(e.target.value)}
      />
      <input
        className="input"
        placeholder="Time (ex.: Vendas, Estoque)"
        value={timeUsuario}
        onChange={e => setTimeUsuario(e.target.value)}
      />
      <input
        className="input"
        placeholder="Email do novo usuário"
        value={novoEmail}
        onChange={e => setNovoEmail(e.target.value)}
      />
      <input
        type="password"
        className="input"
        placeholder="Senha"
        value={novaSenha}
        onChange={e => setNovaSenha(e.target.value)}
      />

      <button className="btn btn-primary" onClick={cadastrarUsuario}>
        Cadastrar Usuário
      </button>

      <p className="mensagem">Apenas o master pode acessar esta tela.</p>
    </div>
  );
}